import {Component} from '@angular/core';
import {HeaderComponent} from '../header/header.component';
import {FooterComponent} from '../Theme/components/footer/footer.component';
import { ROUTER_DIRECTIVES } from '@angular/router';
import { Router } from '@angular/router';
import {HomeService} from './home.service';

@Component({
    selector: 'home',
    template: require('.//home.component.html'),
    directives: [HeaderComponent, FooterComponent, ROUTER_DIRECTIVES],
    providers: [HomeService]
})

export class HomeComponent {

     constructor(private HomeService: HomeService, private _router: Router) {


    }
    private sharePost=false;
    ngOnInit() {
        var token = localStorage.getItem('authToken');
            if(token){
                   this.sharePost = true; 
            }
            // this.HomeService.profile()
            // .subscribe((res) => {
            //     console.log("testing");
            //     console.log(res);
            // });

    }

}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Home/home.component.ts
 **/